jQuery(document).ready(function ($) {
  const loadMore = $('#load-more-casinos');
  let paged = loadMore.data('paged');
  const maxPages = loadMore.data('max-pages');
  const orderbyCriteria = document.querySelector('input[name="orderby"]')
    ? document.querySelector('input[name="orderby"]').value
    :'asc';
  const selectedPaymentMethods = document.getElementById('pay-methods')
    ? document.getElementById('pay-methods').value.split(',')
    : null;
  const selectedGameDevelopers = document.getElementById('games')
    ? document.getElementById('games').value.split(',')
    : null;
  const casinosListIsLoad = new CustomEvent('casinosListLoad', { detail: 'Casinos list is loaded' });

  const addDataPopupLoadedAttribute = (buttons) => {
    buttons.forEach(button => {
      button.setAttribute('data-popup-loaded', true);
    });
  }

  loadMore.click(function (event) {
    event.preventDefault();

    $.ajax({
      method: 'POST',
      url: casinos_list.url,
      data: {
        nonce: casinos_list.nonce,
        paged: paged,
        orderby: orderbyCriteria,
        pm: selectedPaymentMethods,
        gd: selectedGameDevelopers,
        action: 'more_casinos'
      },
      beforeSend: function () {
        loadMore.prop('disabled', true);
      },
      success: function (responce) {
        const openModalButtons = document.querySelectorAll('[data-open-modal]:not([data-popup-loaded="true"]');
        const closeModalButtons = document.querySelectorAll('[data-close-modal]:not([data-popup-loaded="true"]');

        addDataPopupLoadedAttribute(openModalButtons);
        addDataPopupLoadedAttribute(closeModalButtons);
        paged++;
        $('.casinos-list').append(responce);

        if (paged == maxPages) {
          loadMore.remove();
        }

        loadMore.prop('disabled', false);
        document.dispatchEvent(casinosListIsLoad);
      }
    });
  });
}(jQuery));